<template lang="pug">
  .content
    .md-layout
      .md-layout-item.md-size-100(style="text-align: center;")
        h3 Become a paid USIT member to unlock full Portal features
      .md-layout-item.md-medium-size-100.md-size-33
        md-card
          md-card-header(data-background-color='green')
            div.md-title(class="smaller-title") Whole Year
          md-card-content
            h4 $80               
            //- md-button() Unavailable 
            md-button(@click="moveToPay(1)") Select  
      .md-layout-item.md-medium-size-100.md-size-33
        md-card
          md-card-header(data-background-color='green')
            div.md-title(class="smaller-title") Fall
          md-card-content
            h4 $45
            md-button(@click="moveToPay(2)") Select
      .md-layout-item.md-medium-size-100.md-size-33
        md-card
          md-card-header(data-background-color='green')
            div.md-title(class="smaller-title") Spring
          md-card-content
            h4 $45
            md-button(@click="moveToPay(3)") Select 
    md-dialog(:md-active.sync="showDialog" @md-closed="clearDialog" @md-opened="getCheckoutURL")
      md-dialog-title {{productName}}
      md-dialog-content
        .md-layout
          .md-layout.item.md-medium-size-100.md-size-50
            .logo
              .logo-img
                img(:src='imgLogo', alt='USIT LOGO')
          .md-layout.item.md-medium-size-100.md-size-50(style="text-align: center;")
            div(v-if="!showForm" style="margin-left: 40%; margin-top: 20%;")
              loading
            div(v-show="showForm")
              .md-headline {{productName}}
              .md-body-1(style="padding: 5vh 0vh") 
                <br>
                p A paid USIT membership provides access to weekly General Meetings, USIT Trading, Educational/Recruiting Resources, and more.
                <br>
                small *Please note that we will be unable to issue refunds on membership dues
              md-button(:href='checkout_url' class="md-success") Purchase Now
      md-dialog-actions
        md-button(class="md-simple" @click="showDialog = false") Cancel
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      showDialog: false,
      product: null,
      showForm: false,
      paid: false,
      imgLogo: require("@/assets/img/usit-logo-black.png"),
      checkout_url: null,
    };
  },
  mounted() {
    this.styles();
  },
  computed: {
    productName() {
      if(this.product === 1) {
        return 'Whole Year Membership';
      } else if (this.product === 2) {
        return 'Fall Semester Membership';
      } else {
        return 'Spring Semester Membership';
      }
    },
    productPrice() {
      if(this.product === 1) {
        return 80; // 70 is the og price
      } else {
        return 45; // 45 is the og price
      }
    }
  },
  methods: {
    moveToPay(product) {
      this.product = product;
      this.showDialog = true;
    },
    hideDialog() {
      this.showDialog = false;
    },
    clearDialog() {
      this.product = null;
      this.paid = false;
      this.showForm = false;
      this.checkout_url = false;
    },
    styles() {
      let stepperHeaders = document.getElementsByClassName('md-stepper-header');
      let stepperNumbers = document.getElementsByClassName('md-stepper-number');
      for(var i = 0; i < stepperHeaders.length; i++){
        stepperHeaders[i].style.setProperty('background-color', 'white', 'important');
        stepperHeaders[i].style.setProperty('box-shadow', 'none', 'important');
        stepperNumbers[i].style.setProperty('margin-left', '-15px', 'important');
      };
    },
    getCheckoutURL() {
      axios.post('/api/get_checkout_url', {'product': this.product})
      .then((response) => {
        this.checkout_url = response.data.checkout_url;
        this.showForm = true;
      }).catch((err) => {
        console.log(err);
      })
    }
  }
};
</script>
<style scoped>
  .smaller-title {
    font-size: 115%;
    text-align: center;
    font-weight: 300;
  }
  .md-card-content {
    text-align: center;
  }
  .md-stepper-header {
    background-color: white !important;
    box-shadow: none;
  }
  .logo {
    padding: 5vh;
  }
</style>



// WEBPACK FOOTER //
// src/pages/UserManagement/Payment.vue